import { Skeleton } from '@ui/Skeleton';
import { Grid, GridProps } from '@components/Grid';

import s from './ProductsFeedSleketon.sss';

export type ProductsFeedSleketonGridProps = Pick<GridProps, 'def' | 'tablet' | 'desktop'>;

interface Props {
  count?: number,
  grid?: ProductsFeedSleketonGridProps,
  className?: string,
}

export const ProductsFeedSleketon: React.FC<Props> = ({
  count = 4,
  grid = {
    def: 6,
    tablet: 4,
    desktop: 3,
  },
  className,
}) => (
  <Grid
    className={className}
    container={true}
    spacing={10}
  >
    {new Array(count).fill(null).map((_, i) => (
      <Grid
        key={i}
        {...grid}
      >
        <div className={s.photoHolder}>
          <Skeleton
            width="100%"
            height="100%"
          />
          <Skeleton
            className={s.label}
            type="circle"
            theme="white"
            width="24px"
            height="24px"
          />
        </div>
        <div className={s.content}>
          <Skeleton
            width="90%"
            height="14px"
          />
          <Skeleton
            width="70%"
            height="14px"
          />
        </div>
      </Grid>
    ))}
  </Grid>
);
